import createLucideIcon from '../createLucideIcon';

const CornerRightDown = createLucideIcon('CornerRightDownIcon', [
  ['polyline', { points: '10 15 15 20 20 15', key: 'axus6l' }],
  ['path', { d: 'M4 4h7a4 4 0 0 1 4 4v12', key: 'wcbgct' }],
]);

export default CornerRightDown;
